export const REDIRECT = 'REDIRECT_LINK';
export const REGISTER = 'REGISTER';
export const LANGUAGE = 'LANGUAGE';
